import { shopifyComponentCopy, shopifyIndexCopy } from '@testfeed/product-language'
import { houseImagery } from './imagery/houseImagery'
import { HouseEmptyState } from './imagery/HouseEmptyState'
import { NoticeBanner } from './primitives/NoticeBanner'

/** Saved drafts failed to load, so the list may be missing drafts. Never shown as "no tests". */
export function PreparedSetupsDraftsNotice({ draftsError, onRetry }: { draftsError: unknown; onRetry?: () => void }) {
  if (!draftsError) return null
  return (
    <NoticeBanner
      heading={shopifyComponentCopy.testsIndex.draftsErrorTitle}
      tone="warning"
      action={onRetry ? <s-button onClick={onRetry}>{shopifyIndexCopy.retry}</s-button> : undefined}
    >
      <s-paragraph>{shopifyComponentCopy.testsIndex.draftsErrorBody}</s-paragraph>
    </NoticeBanner>
  )
}

export function PreparedSetupsCollectionEmpty({ onCreateStudy }: { onCreateStudy?: () => void }) {
  return (
    <s-section>
      <HouseEmptyState
        heading={shopifyComponentCopy.preparedSetupsPanel.noPreparedSetupsYet003}
        image={houseImagery.preparedSetups}
        action={
          onCreateStudy
            ? { content: shopifyComponentCopy.preparedSetupsPanel.createNewStudy004, onAction: onCreateStudy }
            : undefined
        }
      >
        <p>{shopifyComponentCopy.preparedSetupsPanel.prepareAProductStudySetup005}</p>
      </HouseEmptyState>
    </s-section>
  )
}
